import { Handshake } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "crm",
  icon: Handshake,
  tabs: [
    { to: "/crm/leads", label: "nav.leads", perm: ["crm.lead.read"] },
    { to: "/crm/find-leads", label: "nav.findLeads", perm: ["crm.lead.read"] },
    { to: "/crm/follow-ups", label: "nav.followUps", perm: ["crm.lead.read"] },
    { to: "/crm/visits", label: "nav.visits", perm: ["crm.lead.read"] },
    { to: "/crm/board", label: "nav.deals", perm: ["crm.deal.read"] },
    { to: "/crm/quotes", label: "nav.quotes", perm: ["crm.quote.read"] },
    { to: "/crm/commissions", label: "nav.commissions", perm: ["crm.deal.read"] },
    { to: "/crm/sequences", label: "nav.sequences", perm: ["crm.sequence.read"] },
    { to: "/crm/targets", label: "nav.targets", perm: ["crm.deal.read"] },
    { to: "/crm/reports", label: "nav.salesReports", perm: ["crm.deal.read"] },
  ],
  create: [
    { label: "create.lead", to: "/crm/leads?new=1", perm: "crm.lead.create" },
    { label: "create.quote", to: "/crm/quotes/new", perm: "crm.quote.create" },
  ],
  settings: { to: "/settings/pipelines", perm: ["crm.pipeline.update"] },
  setup: { first_deal: "/crm/leads?new=1" },
};
